import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const SelectableBoxGroupContext = createContext(null);
export const SelectableBoxGroupProvider = ({ children, value, }) => (_jsx(SelectableBoxGroupContext.Provider, { value: value, children: children }));
export const useSelectableBoxGroupContext = () => useContext(SelectableBoxGroupContext);
//# sourceMappingURL=SelectableBoxGroup.context.js.map